import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../utilities/translator';
import { selectActiveDestinationGroups, selectActiveDestinations } from '../mainFilter/selectors';
import { parseStringToJson } from "../../utilities/helpers";
import { selectGlobalLoading } from '../../appSlice';
import cn from 'classnames';
import abTesting from '../../services/abTesting';
import { getParamFromUrl, setParamToUrl } from '../../utilities/urlResolver';

const defaultArray = {
  en: [
    {
      text1: 'It’s all about You',
      text2: 'Endless holiday options wrapped as customizable packages',
      photo: '',
      video: 'https://dyzyahse2i42m.cloudfront.net/holidayfinder/video/hf-prod.mp4',
    },
  ],
};

const HeroSection = ({ children }) => {
  const selectedDestinations = useSelector(selectActiveDestinations);
  const selectedDestinationGroups = useSelector(selectActiveDestinationGroups);
  const { showResults } = useSelector(state => state.app);
  const { default_photo_url, locale } = window.holidayFinder;
  const heroArray = default_photo_url
    ? parseStringToJson(default_photo_url)[locale]
    : defaultArray.en;
  const [backgroundImage, setBackgroundImage] = useState(heroArray[0].photo || null);
  const [label, setLabel] = useState(null);
  const [destination] = selectedDestinations;
  const videoSource = heroArray[0].video || 'https://dyzyahse2i42m.cloudfront.net/holidayfinder/video/hf-prod.mp4';
  const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
  const globalLoading = useSelector(selectGlobalLoading);

  const [firstSlide] = heroArray;

  useEffect(() => {
    const [activeDestination] = selectedDestinations;
    const [activeGroup] = selectedDestinationGroups;

    if (selectedDestinationGroups.length && !getParamFromUrl('pr_destinations') && selectedDestinations.length) {
      // if destinationsGroups are set, but no destinations in the url (fix for the case when EntryPopup is removed)
      const destinationsForGroupsIds = selectedDestinations.map(dest => dest.id);
      if (destinationsForGroupsIds && destinationsForGroupsIds.length) {
        setParamToUrl({ pr_destinations: destinationsForGroupsIds });
      }
    }

    if (selectedDestinations.length === 1) {
      // If there is only one destination selected
      setBackgroundImage(activeDestination.photo || heroArray[0].photo)
      setLabel(t('heroSlider.singleDestinationText', { destination: activeDestination.name }))
    } else if (selectedDestinations.length >= 1 && selectedDestinationGroups.length === 1 && selectedDestinations.every((destination) => destination.destinations_groups.includes(activeGroup.id))) {
      // If there is only one group and all destinations belong to that group
      setBackgroundImage(selectedDestinations[0].photo || heroArray[0].photo)
      setLabel(t('heroSlider.singleGroupText', { group: activeGroup.name }))
    } else if (selectedDestinations.length > 1) {
      // If random destinations are selected
      setBackgroundImage(selectedDestinations[0].photo || heroArray[0].photo)
      setLabel(t('heroSlider.multipleDestinationsText'))
    } else {
      // If no destinations are selected
      setBackgroundImage(heroArray[0]?.photo);
      setLabel(null);
    }
  }, [heroArray, selectedDestinations, selectedDestinationGroups])

  return (
    <div className={cn('hero-section', {
      'customize-hero': window.innerWidth <= 768,
      'customize-mobile': window.innerWidth <= 768 && abTesting.customizeButton,
    })}>
      {globalLoading.heroSectionLoading ? (<div className="hero-section__loader"/> ) : null}
      <div className="z-10">
        <div className="hero-section__bg-overlay-wrap">
          <div className="hero-section__bg-overlay" />
        </div>
        {!isMobile && (
          <div className="hero-section__image-slider">
            {backgroundImage ? (
              <div className="hero-section__image-wrap">
                <div
                  className="hero-section__image"
                  style={{ backgroundImage: `url(${backgroundImage})` }}
                />
              </div>
            ) : (
              <video autoPlay muted loop className="hero-section__video">
                <source src={videoSource} type="video/mp4" />
              </video>
            )}
          </div>
        )}
      </div>

      <div className={cn('z-10 flex flex-col h-full items-end', { 'gap-10 mb-8': !isMobile })}>
        <div className={cn('hero-section__wrap', { 'destinations-selected': destination })}>
          {backgroundImage && showResults && (
            <div className="mobile-hero-background mobileOnly">
              <img src={backgroundImage} alt="" />
            </div>
          )}
          <h1 dir="ltr" className="mb-0">
            {backgroundImage && destination ? (
              <div className="title-wrap heading-huge" dangerouslySetInnerHTML={{ __html: label }} />
            ) : (
              <div>
                <div className="title-wrap heading-huge flex flex-col gap-2 font-semibold">
                  <span className={firstSlide.text2 ? '' : 'big'} dangerouslySetInnerHTML={{ __html: firstSlide.text1 }}></span>
                  {firstSlide.text2 &&
                    <span className="small" dangerouslySetInnerHTML={{__html: firstSlide.text2}} />
                  }
                </div>
              </div>
            )}
          </h1>
        </div>
        {children}
      </div>
    </div>
  );
}

export default React.memo(HeroSection)
